import { PreloaderScreen } from '../../gameClient/webgl/preloaderScreen';

type SetPreloaderHintParams = {
  text: string;
};

export class SetPreloaderHintHandler {
    public handle(params: SetPreloaderHintParams): void {
        PreloaderScreen.getInstance().setHintText(params.text);
    }
}
